import React from "react";

const ProductReport = () => {
  const data = [
    { id: 1, name: "Sample Product", price: 100, sold: 50 },
    { id: 2, name: "Another Product", price: 200, sold: 20 },
  ];

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">📊 Product Report</h1>
      <table className="w-full border">
        <thead className="text-white">
          <tr className="bg-gray-100">
            <th className="border px-3 py-2">ID</th>
            <th className="border px-3 py-2">Name</th>
            <th className="border px-3 py-2">Price</th>
            <th className="border px-3 py-2">Sold</th>
            <th className="border px-3 py-2">Revenue</th>
          </tr>
        </thead>
        <tbody>
          {data.map((p) => (
            <tr key={p.id}>
              <td className="border px-3 py-2">{p.id}</td>
              <td className="border px-3 py-2">{p.name}</td>
              <td className="border px-3 py-2">{p.price}</td>
              <td className="border px-3 py-2">{p.sold}</td>
              <td className="border px-3 py-2">{p.price * p.sold}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductReport;
